import { CommonGlobalService, Client, User } from '@umanforge/common';

export function isAdminOfAllClientsUser( me: User | null, user: User | null ): boolean {
  if ( !me || !user ) {
    return false;
  }
  const clientsOfUser = CommonGlobalService.getUserClients( user );
  return clientsOfUser.every( ( client: Client ) => { return CommonGlobalService.isAdminOfClient( me, client.id ); } );
}